import { defineProfile } from "./define.js";

export const CLINIC_PROFILE = defineProfile("clinic", {
  labels: ["contacts", "bookings", "services", "staff"],
  home: ["bookings_today", "no_shows", "unread_chats", "ai_handoffs"],
  kpis: ["bookings", "no_show_rate", "conversations", "response_time", "ai_handoffs"],
  panel: ["appointments", "past_services"],
  quickActions: ["book_appointment", "send_reminder"],
  contactFields: [
    { key: "birth_date", kind: "date", label: { ar: "تاريخ الميلاد", en: "Birth date" } },
    { key: "allergies", kind: "text", label: { ar: "الحساسية", en: "Allergies" } },
  ],
  aiTools: ["search_kb", "lookup_availability", "book_slot", "escalate"],
  cloudStarterMenu: "appointments_menu",
  starterPack: "clinic",
  replyStyle: {
    emoji: "none",
    format: "paragraph",
    greeting: "short",
    closing: "none",
    length: "normal",
  },
});
